import API_ROUTES from "../constants/api";
import { DEFAULT_ITEMS_PER_PAGE } from "../constants/common";
import HttpUtil from "../http-handler/http-util";

export default class MatAssessmentService {

  static getAssessments(pageNumber = 0, pageSize = DEFAULT_ITEMS_PER_PAGE, sort, regulationId) {
    return HttpUtil.get(
      API_ROUTES.MATERIALITY_ASSESSMENT.LIST
        .replace("<pageNumber>", pageNumber)
        .replace("<pageSize>", pageSize)
        .replace(
          regulationId ? "<regulationId>" : "&regulationId=<regulationId>",
          regulationId
        )
        .replace("<sort>", sort)
    );
  }

  static share(id) {
    return HttpUtil.patch(API_ROUTES.MATERIALITY_ASSESSMENT.SHARE.replace('<id>', id));
  }

  static getSurveyForms(pageNumber = 0, pageSize = DEFAULT_ITEMS_PER_PAGE, companyId) {
    return HttpUtil.get(
      API_ROUTES.MATERIALITY_ASSESSMENT.GET_SURVEY_FORMS
        .replace("<pageNumber>", pageNumber)
        .replace("<pageSize>", pageSize)
        .replace("<companyId>", companyId)
    );
  }


  static getChildrenStakeholders(year, companyId) {
    return HttpUtil.get(
      API_ROUTES.MATERIALITY_ASSESSMENT.GET_STAKEHOLDER_CHILDREN
        .replace('<year>', year)
        .replace('<companyId>', companyId)
    );
  }


  static createAssessment(payload) {
    return HttpUtil.post(API_ROUTES.MATERIALITY_ASSESSMENT.CREATE, payload);
  }

  static updateAssessment(id, payload) {
    return HttpUtil.put(
      API_ROUTES.MATERIALITY_ASSESSMENT.UPDATE.replace('<id>', id),
      payload
    );
  }

  static getReport(reportId) {
    return HttpUtil.getFromReportingService(API_ROUTES.MATERIALITY_ASSESSMENT.GET_REPORT.replace("<reportId>", reportId), {});
  }

  static getLatestReport(year) {
    return HttpUtil.getFromReportingService(API_ROUTES.MATERIALITY_ASSESSMENT.GET_LATEST_REPORT.replace("<year>", year));
  }

  static saveReport(reportId, payload) {
    return HttpUtil.putForReportingService(API_ROUTES.MATERIALITY_ASSESSMENT.GET_REPORT.replace("<reportId>", reportId), payload);
  }

  static getSharedGroupsForAssessment(id) {
    return HttpUtil.get(
      API_ROUTES.MATERIALITY_ASSESSMENT.GET_SHARED_GROUPS
      .replace('<id>', id)
    );
  }

  static reshareAssessment(id, payload) {
    return HttpUtil.patch(API_ROUTES.MATERIALITY_ASSESSMENT.RE_SHARE.replace('<id>', id), payload);
  }

}
